module.exports = __webpack_public_path__ + "img/Primeo_80X30.aa19843b.png";